import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/helpers/composables/useI18n';
import { useUserStore } from '@/helpers/composables/useStores';
import { OfferMonetizationType } from '@/interfaces/titles';
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'FreeTag',
  setup(__props) {

const { buyboxPresentationType, setBuyboxPresentationType } = useUserStore();

const { tc } = useI18n();
const label = computed(() => tc('WEBAPP_FREE'));

const setBuyBoxTypeToFree = () => {
	if (buyboxPresentationType.value !== OfferMonetizationType.FREE) {
		setBuyboxPresentationType({ presentationType: OfferMonetizationType.FREE });
	}
};

return { __sfc: true,buyboxPresentationType, setBuyboxPresentationType, tc, label, setBuyBoxTypeToFree }
}

})